import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const Wrapper = styled.div<{ isSelected: boolean }>`
  position: relative;
  box-sizing: border-box;
  border-radius: ${theme.borderRadius.medium};
  border: ${({ isSelected }) =>
    isSelected
      ? `1px solid ${theme.color.designSystem.purple70}`
      : `1px solid ${theme.color.designSystem.grey20}`};
  margin-top: ${theme.spacing.small};
  margin-bottom: ${theme.spacing.small};
`;

export const IFrame = styled.iframe<{ isLoading: boolean; collapsed: boolean }>`
  max-height: 1200px;
  display: ${({ isLoading, collapsed }) =>
    isLoading || collapsed ? 'none' : 'block'};
`;

export const Form = styled.form`
  display: none;
`;

export const CollapsedLtiBlock = styled.div<{ isSelected: boolean }>`
  background-color: ${({ isSelected }) =>
    isSelected
      ? theme.color.designSystem.purple30
      : theme.color.designSystem.grey20};
  font-weight: ${theme.font.weight.regular};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  border-radius: ${theme.borderRadius.medium};
  padding: calc(${theme.spacing.medium});
`;
